import Image from 'next/image';

import type { NewsThumbnail as NewsThumbnailData } from '@/utils/newsThumbnail';

type Props = {
  thumbnail: NewsThumbnailData | null;
  title: string;
  videoSrc?: string | null;
};

const CONTAINER_CLASS = 'mx-0 mb-0 mt-10 overflow-hidden';

export default function NewsThumbnail({ thumbnail, title, videoSrc }: Props) {
  if (!videoSrc && thumbnail?.alreadyInContent) {
    return null;
  }

  if (videoSrc) {
    return (
      <figure className={CONTAINER_CLASS}>
        <video
          className="block aspect-video w-full bg-black object-contain"
          src={videoSrc}
          poster={thumbnail?.src}
          controls
          muted
          playsInline
          preload="metadata"
          aria-label={title}
        />
      </figure>
    );
  }

  if (!thumbnail) return null;

  return (
    <figure className={CONTAINER_CLASS}>
      <Image
        className="block h-auto w-full"
        src={thumbnail.src}
        alt={title}
        width={thumbnail.width}
        height={thumbnail.height}
        sizes="(min-width: 992px) 700px, calc(100vw - 40px)"
        preload
      />
    </figure>
  );
}
